'use client';

import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CircleCheck as CheckCircle, ArrowRight, Loader as Loader2 } from 'lucide-react';
import { supabase } from '@/lib/supabase-client';

export default function CheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [subscriptionDetails, setSubscriptionDetails] = useState<any>(null);
  
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      if (!sessionId) {
        setIsLoading(false);
        return;
      }

      try {
        // Fetch subscription details from Supabase
        const { data: subscription } = await supabase
          .from('stripe_user_subscriptions')
          .select('*')
          .single();

        setSubscriptionDetails(subscription);
      } catch (error) {
        console.error('Error fetching subscription details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubscriptionDetails();
  }, [sessionId]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p>Processing your subscription...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <CheckCircle className="h-6 w-6 text-green-600" />
          </div>
          <CardTitle className="text-2xl text-green-900">
            Payment Successful!
          </CardTitle>
          <CardDescription>
            Your subscription has been activated successfully
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="text-center space-y-2">
            <p className="text-sm text-gray-600">
              You now have access to your teech coins and can start practicing interviews right away.
            </p>
            
            {subscriptionDetails && (
              <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm font-medium">Active Subscription</p>
                <p className="text-xs text-gray-600">
                  Your coins will be renewed monthly
                </p>
              </div>
            )}
          </div>

          <div className="space-y-2">
            <Button asChild className="w-full">
              <Link to="/dashboard">
                Start Practicing
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            
            <Button variant="outline" asChild className="w-full">
              <Link to="/profile">
                View Profile
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}